import { PitchDeck } from 'data/pitchdecks';
import interceptor from './interceptor';

const getAll = () => {
  const request = interceptor.apiWithAuth.get(
    '/pitchdeck/get-all-pitchdecks-by-projectid'
  );
  return request.then(response => response.data);
};

const getAllTemplates = () => {
  const request = interceptor.apiWithAuth.get('/pitchdeck/get-all-templates');
  return request.then(response => response.data);
};

export const addPitchDeck = (pitchDeck: PitchDeck) => {
  return interceptor.apiWithAuth
    .post('/pitchdeck/add-pitchdeck', pitchDeck)
    .then(response => {
      console.log(response.data);
      const pitchDeckId = response.data;
      return pitchDeckId;
    })
    .catch(error => {
      return Promise.reject(
        error.response ? error.response.data : 'An error occurred'
      );
    });
};

export const updatePitchDeck = (pitchDeck: PitchDeck) => {
  return interceptor.apiWithAuth
    .put('/pitchdeck/update-pitchdeck', pitchDeck)
    .then(response => {
      console.log(response.data);
      return response.data;
    })
    .catch(error => {
      return Promise.reject(
        error.response ? error.response.data : 'An error occurred'
      );
    });
};

export const editPitchDeck = (
  pitchDeckId: string,
  updatedFields: Partial<PitchDeck>
) => {
  const updatedPitchDeck = {
    pitchDeckId: pitchDeckId,
    ...updatedFields // Merge updatedFields with the original pitch deck object
  };

  return interceptor.apiWithAuth
    .put('/pitchdeck/update-pitchdeck', updatedPitchDeck)
    .then(response => {
      console.log(response.data);
      return response.data;
    })
    .catch(error => {
      return Promise.reject(
        error.response ? error.response.data : 'An error occurred'
      );
    });
};

const getPitchDeckByID = (pitchDeckId: string) => {
  const request = interceptor.apiWithoutAuth.get(
    '/pitchdeck/get-pitchdeck-by-id/' + pitchDeckId
  );
  return request
    .then(response => {
      if (response.data.dateCreated) {
        response.data.dateCreated = new Date(
          response.data.dateCreated
        ).toISOString();
      }
      if (response.data.dateModified) {
        response.data.dateModified = new Date(
          response.data.dateModified
        ).toISOString();
      }
      if (response.data.dateDeleted) {
        response.data.dateDeleted = new Date(
          response.data.dateDeleted
        ).toISOString();
      }
      return response.data;
    })
    .catch(error => {
      if (error.response && error.response.status === 404) {
        return Promise.reject('Project not found');
      }
      return Promise.reject(
        error.response ? error.response.data : 'An error occurred'
      );
    });
};

const pitchDeckService = {
  getAll,
  getAllTemplates,
  addPitchDeck,
  updatePitchDeck,
  editPitchDeck,
  getPitchDeckByID
};
export default pitchDeckService;
